export const API_ENDPOINT = "https://csl-backend.staging.nowbst.com/intake-form"

// // QA 
// export const API_ENDPOINT = "https://donorapp-apiqa.cslplasma.com/intake-form"

// PROD 
// export const API_ENDPOINT = "https://donorapp-api.cslplasma.com/intake-form"